import { t } from '@lingui/macro'
import { TextField } from '@material-ui/core'
import { useDebounceCallback } from '@speedlo/hooks'
import React from 'react'
import { IAccount } from 'shopify-payment-core'

import { useAccountRef } from '../hooks/useAccountRef'
import { useSnackBar } from '../hooks/useSnackBar'
import { i18n } from '../i18n'

interface IProps {
  account: IAccount
}

export const AccountInternalNote: React.FC<IProps> = ({ account }) => {
  const accountRef = useAccountRef(account)
  const { enqueueSuccess } = useSnackBar()
  const onChange = useDebounceCallback((adminNote: string) => {
    accountRef.update({ adminNote })
    enqueueSuccess(i18n._(t`Poznámka uložena`))
  }, 100)
  return (
    <TextField
      id="adminNote"
      name="adminNote"
      label={i18n._(t`Interní poznámka`)}
      multiline
      fullWidth
      defaultValue={account.adminNote}
      onChange={ev => onChange(ev.target.value)}
    />
  )
}
